import { render, staticRenderFns } from "./ProductOrder.vue?vue&type=template&id=2a0d7c7d&scoped=true"
import script from "./ProductOrder.vue?vue&type=script&lang=js"
export * from "./ProductOrder.vue?vue&type=script&lang=js"
import style0 from "./ProductOrder.vue?vue&type=style&index=0&id=2a0d7c7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0d7c7d",
  null
  
)

export default component.exports